module.exports = __webpack_public_path__ + "static/imaid-logo-00f3b93711e92e7a2b246190ea1bb1f2.png";